import React, { Component, Fragment } from "react";
import moment from "moment";

//services
import { UtilityService } from "../../services";

class PrintDevelopmentFabric extends Component {
  state = {
    fabric: {}
  };

  componentWillMount() {
    this.setState({
      fabric: this.props.fabric
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fabric != this.props.fabric) {
      this.setState({
        fabric: nextProps.fabric
      });
    }
  }

  render() {
    const { fabric } = this.state;
    return (
      <Fragment>
        <div className="fabricPrintDiv">
          <style>
            {`@media print {
              body{
                  font-family: 'Montserrat', sans-serif;
                  font-size:12px;
              }
              .fabricPrintDiv{
                padding: 10px
                border : 2px solid black;
                top : 0;
                bottom : 0;
              }

              .printrow {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                width: 100%;
              }

              .printcolumn {
                display: flex;
                flex-direction: column;
                flex-basis: 100%;
                flex: 1;
              }
              table>tbody>tr td{
                  font-size:12px;
              }
              .label-text{
                  color:#279588;
                  font-size : 12px;
                  font-weight:bold;
              }
              .blue{
                  color : #146FF9;
              }
              .padding-for-heading{
                padding: 5px;
              }


              .specialComments{
                  width: 100%;
                  border : 1px solid black;
                  min-height : 60px;
                  margin: 10px;
                  padding: 10px!important;
              }

              .b{
                  border: 1px solid black;
                  margin: 10px;
                  padding: 5px;
              }
              .fabric-text{
                font-size:16px;
                color: #279588;
                font-weight: 1000;
              }

              .bold{
                  font-weight:bold;
              }
              .bb-p{
                border-bottom: 1px solid black;
                margin-bottom: 10px ;
              }
              .w-50 {
                  width: 50%;
              }
              table.grid{
                border-collapse: collapse;
                margin-right: 5px;
                margin-left: 5px;
              }
              table.grid>tbody>tr td {
                border: 0.5px solid black;
                text-align: center;
                padding: 2px;
              }
              .width-for-table{
                  width: 50%;
              }
              .text-center{
                text-align: center;
              }
              .p-1{
                padding : 5px;
              }
              .pl-1{
                padding-left: 23px;
              }
              .border-bot{
                border-bottom : 1px solid black;
              }
              .mt{
                margin-top:10px;
              }
              .mtl{
                margin-top:30px;
              }
              .margin{
                margin : 5px;
              }
              .pl-2{
                padding: 5px;
              }
            }`}
          </style>
          <div className="bold text-center p-1 ">
            MAGNUM CLOTHING PVT LTD - FABRIC DEVELOPMENT SHEET - FDS
          </div>
          {/* <div className="printrow">
            <div className="printcolumn label-text text-center">
            </div>
          </div> */}
          <div className="printrow mtl pl-2">
            <div className="printcolumn">
              <div className="fabric-text pl-1 ">
                {(fabric && fabric.fabricNumber) || "F-00009"}
              </div>
              <img
                width="100px"
                height="100px"
                src={UtilityService.fileUrl() + fabric.fabricImage}
                alt={fabric.fabricImage}
              />
            </div>
            <div className="printcolumn">
              <table>
                <tbody>
                  {fabric.development && (
                    <tr>
                      <td className="label-text">DEV NO</td>
                      <td className="bold">{fabric.devRefNumber}</td>
                    </tr>
                  )}
                  <tr>
                    <td className="label-text">SUPPLIER</td>
                    <td className="bold">
                      {fabric.supplierName !== null
                        ? fabric.supplierName.label
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-text">REQUIREMENT</td>
                    <td className="bold">
                      {fabric.requirement !== null ? fabric.requirement : ""}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="printcolumn">
              {fabric.development && (
                <table>
                  <tbody>
                    <tr>
                      {fabric.development && (
                        <td className="label-text">REQUEST DATE </td>
                      )}
                      {fabric.development && (
                        <td className="bold">
                          {fabric.requestDate !== null
                            ? moment(fabric.requestDate).format("DD MMM YYYY")
                            : ""}
                        </td>
                      )}
                    </tr>
                    <tr>
                      <td className="label-text">MAGNUM ETA</td>
                      <td className="bold">
                        {fabric.magnumETADate !== null
                          ? moment(fabric.magnumETADate).format("DD MMM YYYY")
                          : ""}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
          </div>
          <div className="printrow padding-for-heading blue">
            GENERAL INFORMATION
          </div>
          <div className="printrow bb-p">
            <div className="printcolumn">
              <table>
                <tbody>
                  <tr>
                    <td className="label-text">COUNT & CONSTRUCTION</td>
                    <td className="border-bot-dot">
                      {`${fabric.count.warp} * ${fabric.count.weft} /
                        ${fabric.construction.warp} * ${fabric.construction.weft}`}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-text">CLASSIFICATION OF FABRIC</td>
                    <td>{fabric.classificationOfFabric}</td>
                  </tr>
                  <tr>
                    <td className="label-text">QUALITY</td>
                    <td> {fabric.quality}</td>
                  </tr>
                  <tr>
                    <td className="label-text">COMPOSITION</td>
                    <td>{fabric.composition}</td>
                  </tr>
                  <tr>
                    <td className="label-text">BUYER LIGHT SOURCE</td>
                    <td>{fabric.buyerPrimarySource} </td>
                  </tr>
                  <tr>
                    <td className="label-text">GSM</td>
                    <td>{fabric.gsm} </td>
                  </tr>
                  <tr>
                    <td className="label-text">WIDTH</td>
                    <td>{fabric.width} </td>
                  </tr>
                  <tr>
                    <td className="label-text">BASE NO</td>
                    <td>{fabric.bNumber !== null ? fabric.bNumber.label : ""} </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="printcolumn">
              <table>
                <tbody>
                  <tr>
                    <td className="label-text">CUST DESIGN REF NO</td>
                    <td>{fabric.custDefNo} </td>
                  </tr>
                  <tr>
                    <td className="label-text">COLOUR</td>
                    <td>{fabric.colorWay} </td>
                  </tr>
                  <tr>
                    <td className="label-text">ORIGINATION OF ARTWORK</td>
                    <td>
                      {fabric.orginationOfArtwork !== null
                        ? fabric.orginationOfArtwork
                        : ""}{" "}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-text">MAG CAD REF NO</td>
                    <td>{fabric.magCadRefNo}</td>
                  </tr>
                  <tr>
                    <td className="label-text">CUSTOMER - DEPT</td>
                    <td>{fabric.customer !== null ? fabric.customer : ""}</td>
                  </tr>
                  <tr>
                    <td className="label-text">MAG STYLE NO</td>
                    <td>
                      {fabric.magnumStyleId !== null
                        ? fabric.magnumStyleId.label
                        : ""}{" "}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-text">ATTRIBUTES</td>
                    <td>
                      {fabric.attribute !== null ? fabric.attribute : ""}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-text">FILE TRANSFER</td>
                    <td>
                      {fabric.fileTransfer !== null ? fabric.fileTransfer : ""}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {fabric.yarnDyed !== null && (
            <Fragment>
              <div className="printrow blue padding-for-heading">YARN DYED</div>
              <div className="printrow">
                <div className="printcolumn">
                  <table className="grid">
                    <tbody>
                      <tr>
                        <td className="label-text">TYPE OF LOOM</td>
                        <td className="label-text">DYE STUFF</td>
                        <td className="label-text">NO OF COLS ON WEFT</td>
                        <td className="label-text">DESIGN REPEAT SIZE</td>
                        <td className="label-text">WEAVE</td>
                        <td className="label-text">FINISH</td>
                        <td className="label-text">WASH</td>
                      </tr>
                      <tr>
                        <td>
                          {fabric.yarnDyed.typeOfLoom !== null
                            ? fabric.yarnDyed.typeOfLoom
                            : ""}
                        </td>
                        <td>
                          {fabric.yarnDyed.dyeStuff !== null
                            ? fabric.yarnDyed.dyeStuff
                            : ""}
                        </td>
                        <td>
                          {fabric.yarnDyed.noOfColsWeft !== null
                            ? fabric.yarnDyed.noOfColsWeft
                            : ""}
                        </td>
                        <td>
                          {fabric.yarnDyed.designRepeatSize !== null
                            ? fabric.yarnDyed.designRepeatSize
                            : ""}
                        </td>
                        <td>
                          {fabric.yarnDyed.weave !== null
                            ? fabric.yarnDyed.weave
                            : ""}
                        </td>
                        <td>
                          {fabric.yarnDyed.finish !== null
                            ? fabric.yarnDyed.finish
                            : ""}
                        </td>
                        <td>
                          {fabric.yarnDyed.wash !== null
                            ? fabric.yarnDyed.wash
                            : ""}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Fragment>
          )}

          {fabric.print !== null && (
            <Fragment>
              <div className="printrow padding-for-heading blue">PRINT</div>
              <div className="printrow">
                <div className="printcolumn">
                  <table className="grid">
                    <tbody>
                      <tr>
                        <td className="label-text">PRINT TYPE</td>
                        <td className="label-text">PRINT DIRECTION</td>
                        <td className="label-text">PRINT ROUTE</td>
                        <td className="label-text">NO OF COLS</td>
                        <td className="label-text">ROTARY REPEAT SIZE</td>
                        <td className="label-text">LAYER FILE</td>
                        <td className="label-text">ARTWORK WITH COL SQUARES</td>
                        <td className="label-text">FLUROSCENT COLS</td>
                      </tr>
                      <tr>
                        <td>
                          {fabric.print.printType !== null
                            ? fabric.print.printType
                            : ""}
                        </td>
                        <td>
                          {fabric.print.printDirection !== null
                            ? fabric.print.printDirection
                            : ""}
                        </td>
                        <td>
                          {fabric.print.printRoute !== null
                            ? fabric.print.printRoute
                            : ""}
                        </td>
                        <td>
                          {fabric.print.noOfColors !== null
                            ? fabric.print.noOfColors
                            : ""}
                        </td>
                        <td>
                          {fabric.print.rotaryRepeatSize !== null
                            ? fabric.print.rotaryRepeatSize
                            : ""}
                        </td>
                        <td>
                          {fabric.print.layerFile !== null
                            ? fabric.print.layerFile
                              ? "YES"
                              : "NO"
                            : ""}
                        </td>
                        <td>
                          {fabric.print.artworkWithColSquare !== null
                            ? fabric.print.artworkWithColSquare
                              ? "YES"
                              : "NO"
                            : ""}
                        </td>
                        <td>
                          {fabric.print.fluroscentCols !== null
                            ? fabric.print.fluroscentCols
                              ? "YES"
                              : "NO"
                            : ""}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Fragment>
          )}

          {fabric.embroidery !== null && (
            <Fragment>
              <div className="printrow padding-for-heading blue">
                EMBROIDERY
              </div>
              <div className="printrow">
                <div className="printcolumn">
                  <table className="grid">
                    <tbody>
                      <tr>
                        <td className="label-text">BASE QUALITY</td>
                        <td className="label-text">THREAD QUALITY</td>
                        <td className="label-text">MACHINE TYPE</td>
                        <td className="label-text">DESIGN DESCRIPTION</td>
                        <td className="label-text">EMB TECHNIQUE</td>
                        <td className="label-text">TARGET PRICE</td>
                        <td className="label-text">BACKING DETAILS</td>
                      </tr>
                      <tr>
                        <td>
                          {fabric.embroidery.fabricBase !== null
                            ? fabric.embroidery.fabricBase
                            : ""}
                        </td>
                        <td>
                          {fabric.embroidery.threadQuality !== null
                            ? fabric.embroidery.threadQuality
                            : ""}
                        </td>
                        <td>
                          {fabric.embroidery.machineType !== null
                            ? fabric.embroidery.machineType
                            : ""}
                        </td>
                        <td>
                          {fabric.embroidery.designDescription !== null
                            ? fabric.embroidery.designDescription
                            : ""}
                        </td>
                        <td>
                          {fabric.embroidery.embTechinique !== null
                            ? fabric.embroidery.embTechinique
                            : ""}
                        </td>
                        <td>
                          {fabric.embroidery.targetRate !== null
                            ? fabric.embroidery.targetRate
                            : ""}
                        </td>
                        <td>
                          {fabric.embroidery.backingDetails !== null
                            ? fabric.embroidery.backingDetails
                            : ""}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="printrow mt">
                <div className="printcolumn">
                  <table className="grid">
                    <tbody>
                      <tr>
                        <td className="label-text">BACKING </td>
                        <td className="label-text">GRADING REQD</td>
                        <td className="label-text">MARKER</td>
                        <td className="label-text">SCALLOPING</td>
                      </tr>
                      <tr>
                        <td>
                          {fabric.embroidery.backing !== null
                            ? fabric.embroidery.backing
                              ? "YES"
                              : "NO"
                            : ""}{" "}
                        </td>
                        <td>
                          {fabric.embroidery.gradingRequired !== null
                            ? fabric.embroidery.gradingRequired
                              ? "YES"
                              : "NO"
                            : ""}
                        </td>
                        <td>
                          {fabric.embroidery.marker !== null
                            ? fabric.embroidery.marker
                              ? "YES"
                              : "NO"
                            : ""}
                        </td>
                        <td>
                          {fabric.embroidery.scalloping !== null
                            ? fabric.embroidery.scalloping
                              ? "YES"
                              : "NO"
                            : ""}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Fragment>
          )}
          {fabric.solidGreige !== null && (
            <Fragment>
              <div className="printrow padding-for-heading blue">
                GREIGE / DENIM
              </div>
              <div className="printrow">
                <div className="printcolumn">
                  <table className="grid width-for-table">
                    <tbody>
                      <tr>
                        <td className="label-text">TYPE OF LOOM </td>
                        <td className="label-text">WEAVE</td>
                        <td className="label-text">DESIGN</td>
                      </tr>
                      <tr>
                        <td>
                          {fabric.solidGreige.typeOfLoom !== null
                            ? fabric.solidGreige.typeOfLoom
                            : ""}{" "}
                        </td>
                        <td>
                          {fabric.solidGreige.weave !== null
                            ? fabric.solidGreige.weave
                            : ""}
                        </td>
                        <td>
                          {fabric.solidGreige.designDescription !== null
                            ? fabric.solidGreige.designDescription
                            : ""}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Fragment>
          )}

          {fabric.supplierSection !== null && (
            <Fragment>
              <div className="printrow padding-for-heading blue">
                SUPPLIER SECTION
              </div>
              {fabric.supplierSection.fullPackageData.length > 0 && (
                <Fragment>
                  {fabric.supplierSection.fullPackageData &&
                    fabric.supplierSection.fullPackageData.map((data, i) => {
                      return (
                        <Fragment>
                          {data.default && (
                            <Fragment>
                              <div className="printrow padding-for-heading blue">
                                FULL PACKAGE
                              </div>
                              <div className="printrow">
                                <div className="printcolumn">
                                  <table className="grid">
                                    <tbody>
                                      <tr>
                                        <td className="label-text">PURPOSE</td>
                                        <td className="label-text">DATE</td>
                                        <td className="label-text">
                                          SUPPLIER NAME
                                        </td>
                                        <td className="label-text">
                                          SUPPLIER REF
                                        </td>
                                        <td className="label-text">
                                          LT (DAYS)
                                        </td>
                                        <td className="label-text">WIDTH</td>
                                        <td className="label-text">$/₹</td>
                                        <td className="label-text">PRICE</td>
                                        <td className="label-text">UNITS</td>
                                        <td className="label-text">GST%</td>
                                        <td className="label-text">TRANS</td>
                                        <td className="label-text">
                                          TOTAL COST
                                        </td>
                                        <td className="label-text">DEFAULT</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          {data.purposeLabel !== null
                                            ? data.purposeLabel
                                            : ""}
                                        </td>
                                        <td>
                                          {data.date !== null
                                            ? moment(data.date).format(
                                              "MMM Do YYYY"
                                            )
                                            : ""}
                                        </td>
                                        <td>
                                          {data.SupplierNameLabel !== null
                                            ? data.SupplierNameLabel
                                            : ""}
                                        </td>
                                        <td>
                                          {data.supplierRef !== null
                                            ? data.supplierRef
                                            : ""}
                                        </td>
                                        <td>
                                          {data.leadTime !== null
                                            ? data.leadTime
                                            : ""}
                                        </td>
                                        <td>
                                          {data.width !== null
                                            ? data.width
                                            : ""}
                                        </td>
                                        <td>
                                          {data.currency !== null
                                            ? data.currency === "rupee"
                                              ? "₹"
                                              : "$"
                                            : ""}
                                        </td>
                                        <td>
                                          {data.price !== null
                                            ? data.currency === "rupee"
                                              ? `₹${data.price}`
                                              : `$${data.price}`
                                            : ""}
                                        </td>
                                        <td>
                                          {data.MY !== null ? data.MY : ""}
                                        </td>
                                        <td>
                                          {data.GST !== null &&
                                            data.currency === "rupee"
                                            ? data.GST
                                            : "N/A"}
                                        </td>
                                        <td>
                                          {data.transport !== null &&
                                            data.currency === "rupee"
                                            ? data.transport
                                            : "N/A"}
                                        </td>
                                        <td>
                                          {data.totalCost !== null
                                            ? data.totalCost
                                            : ""}
                                        </td>
                                        <td>
                                          {data.default !== null
                                            ? data.default
                                              ? "YES"
                                              : "NO"
                                            : ""}
                                        </td>
                                      </tr>

                                      <br />
                                      {data.currency === "dollar" && (
                                        <Fragment>
                                          <tr>
                                            <td className="label-text">
                                              CONVERSION TO INR
                                            </td>
                                            <td className="label-text">
                                              SHIPMENT TERM
                                            </td>
                                            <td className="label-text">
                                              SHIPMENT MODE
                                            </td>
                                            <td className="label-text">
                                              PORT OF PICKUP
                                            </td>
                                            <td className="label-text">
                                              FREIGHT COSTS ₹
                                            </td>
                                            <td className="label-text">
                                              CLEARANCE ₹
                                            </td>
                                            <td className="label-text">
                                              DUTY %
                                            </td>
                                            <td className="label-text">
                                              TOTAL ORDER QUANTITY
                                            </td>
                                            <td className="label-text">
                                              WIDTH
                                            </td>
                                            <td className="label-text">GSM</td>
                                            <td className="label-text">
                                              WEIGHT - FABRIC/MTR
                                            </td>
                                            <td className="label-text">
                                              WEIGHT - FULL ORDER
                                            </td>
                                            <td className="label-text">
                                              FREIGHT RATE/KG{" "}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              {data.currencyData &&
                                                data.currencyData
                                                  .conversionToINR !== null &&
                                                data.currencyData
                                                  .conversionToINR !== undefined
                                                ? data.currencyData
                                                  .conversionToINR
                                                : ""}
                                            </td>
                                            <td>
                                              {data.currencyData &&
                                                data.currencyData.shipmentTerm !==
                                                null &&
                                                data.currencyData.shipmentTerm !==
                                                undefined
                                                ? data.currencyData.shipmentTerm
                                                : ""}
                                            </td>
                                            <td>
                                              {data.currencyData &&
                                                data.currencyData.shipmentMode !==
                                                null &&
                                                data.currencyData.shipmentMode !==
                                                undefined
                                                ? data.currencyData.shipmentMode
                                                : ""}
                                            </td>
                                            <td>
                                              {data.currencyData &&
                                                data.currencyData.portOfPickup !==
                                                null &&
                                                data.currencyData.portOfPickup !==
                                                undefined
                                                ? data.currencyData.portOfPickup
                                                : ""}
                                            </td>
                                            <td>
                                              {data.currencyData &&
                                                data.currencyData.freightCosts !==
                                                null &&
                                                data.currencyData.freightCosts !==
                                                undefined
                                                ? data.currencyData.freightCosts
                                                : ""}
                                            </td>
                                            <td>
                                              {data.currencyData &&
                                                data.currencyData.clearance !==
                                                null &&
                                                data.currencyData.clearance !==
                                                undefined
                                                ? data.currencyData.clearance
                                                : ""}
                                            </td>
                                            <td>
                                              {data.currencyData &&
                                                data.currencyData.duty !== null &&
                                                data.currencyData.duty !==
                                                undefined
                                                ? data.currencyData.duty
                                                : ""}
                                            </td>
                                            <td>
                                              {data.currencyData &&
                                                data.currencyData
                                                  .totalOrderQuantity !== null &&
                                                data.currencyData
                                                  .totalOrderQuantity !==
                                                undefined
                                                ? data.currencyData
                                                  .totalOrderQuantity
                                                : ""}
                                            </td>
                                            <td>
                                              {data.currencyData &&
                                                data.currencyData.width !==
                                                null &&
                                                data.currencyData.width !==
                                                undefined
                                                ? data.currencyData.width
                                                : ""}
                                            </td>
                                            <td>
                                              {data.currencyData &&
                                                data.currencyData.gsm !== null &&
                                                data.currencyData.gsm !==
                                                undefined
                                                ? data.currencyData.gsm
                                                : ""}
                                            </td>
                                            <td>
                                              {data.currencyData &&
                                                data.currencyData
                                                  .weightOfFabricPerMtr !==
                                                null &&
                                                data.currencyData
                                                  .weightOfFabricPerMtr !==
                                                undefined
                                                ? data.currencyData
                                                  .weightOfFabricPerMtr
                                                : ""}
                                            </td>
                                            <td>
                                              {data.currencyData &&
                                                data.currencyData
                                                  .weightForFullOrder !== null &&
                                                data.currencyData
                                                  .weightForFullOrder !==
                                                undefined
                                                ? data.currencyData
                                                  .weightForFullOrder
                                                : ""}
                                            </td>
                                            <td>
                                              {data.currencyData &&
                                                data.currencyData
                                                  .freightRatePerKg !== null &&
                                                data.currencyData
                                                  .freightRatePerKg !== undefined
                                                ? data.currencyData
                                                  .freightRatePerKg
                                                : ""}
                                            </td>
                                          </tr>
                                        </Fragment>
                                      )}
                                    </tbody>
                                  </table>
                                  <div className="printrow padding-for-heading blue">
                                    FULL PACKAGE - SPECIAL COMMENTS
                                  </div>
                                  <div className="printrow">
                                    <div className="specialComments">
                                      {data.specialComments
                                        .split("\n")
                                        .map(comment => {
                                          return <p>{comment}</p>;
                                        })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Fragment>
                          )}
                        </Fragment>
                      );
                    })}
                </Fragment>
              )}
              {fabric.supplierSection.jobWorkData.length > 0 && (
                <Fragment>
                  {fabric.supplierSection &&
                    fabric.supplierSection.jobWorkData &&
                    fabric.supplierSection.jobWorkData.length > 0 &&
                    fabric.supplierSection.jobWorkData.map((data, i) => {
                      return (
                        <Fragment>
                          {data.default && (
                            <Fragment>
                              <div className="printrow padding-for-heading blue">
                                JOB WORK
                              </div>
                              <div className="printrow">
                                <div className="printcolumn">
                                  <table className="grid">
                                    <tbody>
                                      <tr>
                                        <td className="label-text">
                                          OPTION - {data.purposeLabel}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="label-text">PROCESS</td>
                                        <td className="label-text">DATE</td>
                                        <td className="label-text">
                                          SUPPLIER NAME
                                        </td>
                                        <td className="label-text">
                                          LT (DAYS)
                                        </td>
                                        <td className="label-text">WIDTH</td>
                                        <td className="label-text">$/₹</td>
                                        <td className="label-text">PRICE</td>
                                        <td className="label-text">VL%</td>
                                        <td className="label-text">COST</td>
                                      </tr>
                                      {data.rowData.map((row, index) => {
                                        return (
                                          <Fragment>
                                            {row.process.length > 0 && (
                                              <tr>
                                                <td>{row.process}</td>
                                                <td>
                                                  { row.date !== null ? moment(row.date).format(
                                                    "MMM Do YYYY"
                                                  ) : ""}
                                                </td>
                                                <td>{row.SupplierNameLabel}</td>
                                                <td>{row.leadTime}</td>
                                                <td>{row.width}</td>
                                                <td>
                                                  {row.currency === "dollar"
                                                    ? "$"
                                                    : "₹"}
                                                </td>
                                                <td>{row.price}</td>
                                                <td>{row.vl}</td>
                                                <td>{row.cost}</td>
                                              </tr>
                                            )}
                                          </Fragment>
                                        );
                                      })}
                                      <tr>
                                        <td className="label-text"></td>
                                        <td className="label-text"></td>
                                        <td className="label-text"></td>
                                        <td className="label-text"></td>
                                        <td className="label-text"></td>
                                        <td className="label-text"></td>
                                        <td className="label-text">GST</td>
                                        <td>{data.GST}%</td>
                                        <td>
                                          {data.totalCost - data.transport}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="label-text"></td>
                                        <td className="label-text"></td>
                                        <td className="label-text"></td>
                                        <td className="label-text"></td>
                                        <td className="label-text"></td>
                                        <td className="label-text"></td>
                                        <td className="label-text">
                                          Transport
                                        </td>
                                        <td>{data.transport}</td>
                                        <td>{data.totalCost}</td>
                                      </tr>
                                      <tr>
                                        <td className="label-text">
                                          MOQ - {data.moq}
                                        </td>
                                        <td className="label-text">
                                          Total Lead Time - {data.totalLeadTime}
                                        </td>
                                        <td className="label-text">
                                          Finished Width - {data.finishedWidth}
                                        </td>
                                        <td className="label-text">
                                          Cuttable Width - {data.cuttableWidth}
                                        </td>
                                        <td className="label-text"></td>
                                        <td className="label-text"></td>
                                        <td className="label-text"></td>
                                        <td className="label-text">
                                          Total Cost
                                        </td>
                                        <td>{data.totalCost}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <div className="printrow padding-for-heading blue">
                                    JOB WORK - SPECIAL COMMENTS
                                  </div>
                                  <div className="printrow">
                                    <div className="specialComments">
                                      {data.specialComments
                                        .split("\n")
                                        .map(comment => {
                                          return <p>{comment}</p>;
                                        })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Fragment>
                          )}
                        </Fragment>
                      );
                    })}
                </Fragment>
              )}
            </Fragment>
          )}

          <div className="printrow padding-for-heading blue">
            SPECIAL COMMENTS
          </div>
          <div className="printrow">
            <div className="specialComments">
              {fabric.specialComments.split("\n").map(comment => {
                return <p>{comment}</p>;
              })}
            </div>
          </div>
          <div className="printrow padding-for-heading blue">IMAGES</div>
          <div className="printrow">
            {fabric.refImages &&
              fabric.refImages.map(data => {
                return (
                  <div className="margin">
                    <img
                      width="50px"
                      height="50px"
                      src={UtilityService.fileUrl() + data.path}
                    />
                  </div>
                );
              })}
          </div>
          <div id="imgsupplier" className="printrow"></div>
        </div>
      </Fragment>
    );
  }
}

export default PrintDevelopmentFabric;


// WEBPACK FOOTER //
// ./src/components/PrintDevelopmentFabric/index.js